<template>
	<div>
		<v-layout wrap v-for="area in areas" :key="area.id">
			<v-flex xs12 px-5 mt-3>
				<span class="small font-weight-bold info--text">{{ area.name }}</span>
			</v-flex>
			<v-flex xs12 px-5>
				<progress-bar-component :value="5" :quantity="5"></progress-bar-component>
			</v-flex>
			<v-flex xs12 px-5>
				<v-layout wrap>
					<v-flex xs8>
						<span class="caption font-weight-bold primary--text">Factores</span>
					</v-flex>
					<v-flex xs4>
						<span class="caption font-weight-bold primary--text">Cant. Preguntas</span>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 px-4 mx-3
				v-for="factor in localFactors.filter(lf => lf.criterionId === area.id)" :key="factor.id"
				class="border-top">
				<v-divider></v-divider>
				<v-layout wrap px-2 py-1>
					<v-flex xs8>
						<span class="caption info--text">{{ factor.name }}</span>
					</v-flex>
					<v-flex xs4 text-xs-center>
						<span class="caption info--text">{{ factor.totalQuestions }}</span>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import progressBarComponent from '@/components/polls/progress-bar-component';

	export default {
		name: 'questions-detail',
		components: {
			progressBarComponent,
		},
		props: {
			areas: {
				default: () => [],
				type: Array,
			},
			localFactors: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/surveys/questions-detail.vue